import { createAsyncThunk } from "@reduxjs/toolkit";
import expertsService from "services/experts";
import { fetchFamousExperts, fetchNewComerExperts } from "./home";
import { triggerAlert } from "../reducers/appSlice";
import { translateFrontEndAlerts } from "../../utils/translation";

export const getFavoriteExpertsList = createAsyncThunk(
  "get/favoriteExperts",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await expertsService.fetchFavoriteExpertsList();
      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const getExpertById = createAsyncThunk(
  "get/expertById",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await expertsService.getExpertById(data);
      return {
        ...response.data,
        pack_lessons: response.data.pack_lessons.map((packLesson: any) => {
          return {
            ...packLesson,
            point_per_lession: packLesson.points,
          };
        }),
      };
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const addFavouriteExpert = createAsyncThunk(
  "add/favouriteExpert",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const addFavouriteRequestData = {
        expert_id: data.expert_id,
      };
      const res = await expertsService.addFavouriteExpert(
        addFavouriteRequestData
      );
      dispatch(getFavoriteExpertsList(null));
      dispatch(getAllExperts(null));
      dispatch(fetchFamousExperts());
      dispatch(fetchNewComerExperts());
      dispatch(
        triggerAlert({
          type: "success",
          children: data.isFavoriteExpert
            ? data.expertName + translateFrontEndAlerts(26004)
            : data.expertName + translateFrontEndAlerts(26001),
        })
      );
      return res;
    } catch (err: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateFrontEndAlerts(26002) +
            data.expertName +
            translateFrontEndAlerts(26003),
        })
      );
      return rejectWithValue(err);
    }
  }
);
// * get all experts
export const getAllExperts = createAsyncThunk(
  "get-all-experts",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      return await expertsService.getAllExperts(data);
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);

export const getBookmarkedExperts = createAsyncThunk(
  "get-bookmarked-experts",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      return await expertsService.getBookmarkedExpert();
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);

export const getTeacherById = createAsyncThunk(
  "get/teacher/byid",
  async (id: number, { rejectWithValue }) => {
    try {
      return await expertsService.getTeacherById(id);
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);
